import React, { useEffect, useState } from "react";

import makeStyles from "@mui/styles/makeStyles";
import withStyles from "@mui/styles/withStyles";
import classnames from "classnames";

import { DefaultTooltip } from "../Tooltip";

type Props = {
  value?: string;
  backgroundColor?: string;
  dataCy?: string;
  textColor?: string;
  classes?: any;
  className?: string;
  style?: React.CSSProperties;
  leftIcon?: React.ReactNode;
};

const styles = () => ({
  customBadge: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: (props: { textColor?: string; backgroundColor?: string }) =>
      props?.backgroundColor,
    minWidth: "51px",
    padding: "6px 16px",
    height: "40px",
    borderRadius: "20px",
    maxWidth: "148px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    cursor: "default",
    width: "fit-content",
  },
  textValue: {
    color: (props: { textColor?: string }) => props?.textColor,
    fontFamily: "Inter",
    fontSize: "10px",
    fontWeight: 600,
    lineHeight: "20px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    maxWidth: "148px",
    width: "fit-content",
  },
});

const badgeTextCSS = makeStyles(() => ({
  badgeAlign: {
    textAlign: "center",
    display: "block",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    maxWidth: "148px",
    width: "fit-content",
  },
}));

const SimpleBadge = (props: Props) => {
  const { classes, value, className, dataCy, style } = props;
  const clasz = badgeTextCSS();
  const [isTooltipVisible, setIsTooltipVisible] = useState<boolean>(false);

  useEffect(() => {
    if (value) {
      const hasEllipsis = value.length > 20;

      setIsTooltipVisible(hasEllipsis);
    }
  }, []);

  return (
    <div className={classnames(clasz.badgeAlign, classes.customBadge, className)} style={style}>
      {isTooltipVisible ? (
        <DefaultTooltip title={value || ""} placement="top-start">
          <span
            className={classes.textValue}
            data-cy={dataCy}
            style={{ display: "inline-flex", alignItems: "center", gap: 2 }}
          >
            {props.leftIcon && (
              <span style={{ display: "flex", alignItems: "center" }}>{props.leftIcon}</span>
            )}
            {value}
          </span>
        </DefaultTooltip>
      ) : (
        <span
          className={classes.textValue}
          data-cy={dataCy}
          style={{ display: "inline-flex", alignItems: "center", gap: 2 }}
        >
          {props.leftIcon && (
            <span style={{ display: "flex", alignItems: "center" }}>{props.leftIcon}</span>
          )}
          {value}
        </span>
      )}
    </div>
  );
};

const StyledBadge = withStyles(styles)(SimpleBadge);

export default StyledBadge;
